import { QueryCache, QueryClient } from '@tanstack/react-query';
import { startApp } from './app/start';
import { SESSION_QUERY_KEY } from './shared/session';
import { isUnauthorized } from './shared/api';
import './app/index.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { retry: 1, refetchOnWindowFocus: false, staleTime: 30_000 },
  },
  queryCache: new QueryCache({
    // §18: истёкшая или отозванная сессия отвечает 401. Перечитываем bootstrap —
    // охрана маршрута сама вернёт человека на экран входа.
    onError: (error) => {
      if (isUnauthorized(error))
        void queryClient.invalidateQueries({ queryKey: SESSION_QUERY_KEY });
    },
  }),
});

const root = document.getElementById('root');
if (!root) throw new Error('Не найден корневой элемент #root');

// Без top-level await: он требует целевой платформы новее, чем собирает Vite.
void startApp(root, queryClient);
